/**
 * Tiny inline "loading vault…" indicator used while we resolve the session.
 * Sits in the centre of the viewport so it doesn't feel like the app froze.
 */
const QUICK_QUIPS = [
  "checking your credentials…",
  "dusting off your vault…",
  "loading your existential CV…",
  "rummaging for your references…",
];

export default function LoadingVault() {
  const quip = QUICK_QUIPS[Math.floor(Math.random() * QUICK_QUIPS.length)];
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-[var(--brand-bg)] noise"
      data-testid="loading-vault">
      <div className="vault-unlock-progress" aria-hidden="true">
        <span/><span/><span/>
      </div>
      <p className="font-mono-d text-xs uppercase tracking-[0.2em] text-[var(--brand-muted)]">{quip}</p>
    </div>
  );
}
